import {
  ICalculativeInputFieldConfigurationClient,
  ICalculativeInputFieldConfigurationServer,
  IExpression,
  IFunction,
} from "./interface";
import { IFieldsMap } from "@common/redux/formBuilder/interface";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect";
import { FieldProps } from "../FormFieldSelector/interfaces";
import { IFieldSubmissionMap } from "@common/redux/formSubmission/interface";
import { FormFieldTypes } from "../SelectFieldContainer/formFieldTypesInterface";
import { getAction } from "./components/getActionLabel";
export const enum FunctionEnum {
  Add = "Add",
  DaysBetween = "DaysBetween",
}
export const transformCalculativeInputFieldConfigClientToServer = (
  fieldConfigClient: ICalculativeInputFieldConfigurationClient
): ICalculativeInputFieldConfigurationServer => {
  const {
    placeholder,
    initialValue,
    expression,
    isRoundedNumber,
    configureDecimal,
    writeJavascript,
  } = fieldConfigClient;
  const fieldConfigServer = {
    placeHolder: placeholder,
    initialValue: initialValue,
    expression: transformExpressionFromClientToServer(expression),
    isRoundedNumber: isRoundedNumber,
    configureDecimal: configureDecimal,
    writeJavascript: writeJavascript,
  };
  return fieldConfigServer;
};

export const transformCalculativeInputConfigServerToClient = (
  fieldConfigServer: ICalculativeInputFieldConfigurationServer
): ICalculativeInputFieldConfigurationClient => {
  const {
    placeHolder,
    initialValue,
    expression,
    isRoundedNumber,
    configureDecimal,
    writeJavascript,
  } = fieldConfigServer;
  const fieldConfigClient = {
    placeholder: placeHolder,
    initialValue: initialValue,
    expression: transformExpressionFromServerToClient(expression),
    isRoundedNumber: isRoundedNumber,
    configureDecimal: configureDecimal,
    writeJavascript: writeJavascript,
  };

  return fieldConfigClient;
};

export enum ExpressionType {
  FIELD = "FIELD",
  OPERATOR = "OPERATOR",
  TEXT = "TEXT",
  BRACKETS = "BRACKETS",
  FUNCTION = "FUNCTION",
}

export const getFilteredFieldsnameAndIdSelectorForCalculation = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): IOption[] => {
  const filteredFieldOptions: IOption[] = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const { title = "", isSection, fieldType = "", fields } = fieldData;

    const checkIsSection = isSection || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: title || "Untitled field",
        value: key,
        // fieldType,
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};

export const fieldTypesToIgnoreInCalculation = [
  FormFieldTypes["TEXT_INPUT"],
  FormFieldTypes["TEXT_AREA"],
  FormFieldTypes["MULTIPLE_CHOICES"],
  FormFieldTypes["DROPDOWN"],
  FormFieldTypes["DATE_INPUT"],
  FormFieldTypes["TIME_PICKER"],
  //  FormFieldTypes["LINEAR_SCALING"],
  FormFieldTypes["FILE_UPLOAD"],
  //  FormFieldTypes["CURRENCY"],
  FormFieldTypes["RATING"],
  FormFieldTypes["DATE_TIME_PICKER"],
  FormFieldTypes["CHECK_BOX"],
  FormFieldTypes["DECISION_BOX"],
  //  FormFieldTypes["CALCULATIVE"],
  FormFieldTypes["PAYMENT"],
  FormFieldTypes["GEOLOCATION"],
  FormFieldTypes["BLANK_BOX"],
  FormFieldTypes["DATA_GRID"],
  FormFieldTypes["DESCRIPTION"],
  FormFieldTypes["SECTION"],
  FormFieldTypes["BANNER"],
];

export const operatorType = [
  {
    operatorLabel: "(",
    operatorValue: "(",
  },
  {
    operatorLabel: ")",
    operatorValue: ")",
  },
  {
    operatorLabel: "/",
    operatorValue: "/",
  },
  {
    operatorLabel: "*",
    operatorValue: "*",
  },
  {
    operatorLabel: "7",
    operatorValue: "7",
  },
  {
    operatorLabel: "8",
    operatorValue: "8",
  },
  {
    operatorLabel: "9",
    operatorValue: "9",
  },
  {
    operatorLabel: "-",
    operatorValue: "-",
  },
  {
    operatorLabel: "4",
    operatorValue: "4",
  },
  {
    operatorLabel: "5",
    operatorValue: "5",
  },
  {
    operatorLabel: "6",
    operatorValue: "6",
  },
  {
    operatorLabel: "+",
    operatorValue: "+",
  },
  {
    operatorLabel: "1",
    operatorValue: "1",
  },
  {
    operatorLabel: "2",
    operatorValue: "2",
  },
  {
    operatorLabel: "3",
    operatorValue: "3",
  },
  {
    operatorLabel: ".",
    operatorValue: ".",
  },
  {
    operatorLabel: "%",
    operatorValue: "%",
  },
  {
    operatorLabel: "0",
    operatorValue: "0",
  },
  {
    operatorLabel: "**",
    operatorValue: "**",
  },
];
export const textType = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."];
export const bracketType = ["(", ")"];
export const operators = ["+", "-", "*", "/", "%", "**"];
export const functions = [
  {
    title: "Date",
    items: ["Daydiff", "Monthdiff", "Yeardiff", "Age"],
  },
  {
    title: "Decimal",
    items: ["Roundup", "Rounddown", "Round"],
  },
  {
    title: "Time",
    items: ["Hourdiff", "Minutediff", "Seconddiff"],
  },
  {
    title: "Choice",
    items: ["SelectionCount"],
  },
];

export const validateExpression = (expressions: IExpression[]): string => {
  let validationError = ""; // make empty string after completion
  let closingBracketCount = 0;
  let openingBracketCount = 0;
  let fieldExistInFormula = false;

  for (let index = 0; index < expressions.length; index++) {
    const expData = expressions[index];
    const prevExpData: IExpression = expressions[index - 1];
    const nextExpData: IExpression = expressions[index + 1];
    const expValue = expData?.value;
    const fieldId = expData?.fieldId;
    if (fieldId) {
      fieldExistInFormula = true;
    }
    if (expData.type === ExpressionType.FUNCTION) {
      return ``;
    }
    // 0. every opening bracket must have a closing bracket pair.
    if (expValue == ")") {
      closingBracketCount = closingBracketCount + 1;
    } else if (expValue == "(") {
      openingBracketCount = openingBracketCount + 1;
    }
    // 1. Expression should not start with operators (+,-,/,*,%)
    if (index == 0 && operators.includes(expValue)) {
      return "Please add valid expression, Expression should not start with operators (+,-,/,*,%)";
    }
    // 2. Expression should not end with operators (+,-,/,*,%)
    if (index == expressions.length - 1 && operators.includes(expValue)) {
      return "Please add valid expression, Expression should not end with operators (+,-,/,*,%)";
    }
    //3. if you are adding a field, then the previous expression should end with operator or brackets
    if (
      index !== 0 &&
      fieldId &&
      !operators.includes(prevExpData?.value) &&
      !bracketType.includes(prevExpData?.value)
    ) {
      return "Please add valid expression, If you are adding a field, then the previous item must be operator";
    }
    //4. if your previous expression is field, then your current expression should start with operator or brackets
    if (
      index !== expressions.length - 1 &&
      prevExpData?.fieldId &&
      !operators.includes(expValue) &&
      !bracketType.includes(expValue)
    ) {
      return "Please add valid expression, If your previous expression is field, then your current expression should start with symbol";
    }
    //5. if bracket closed then next expression should start with operator
    if (
      index !== expressions.length - 1 &&
      expValue == ")" &&
      nextExpData?.value !== ")" &&
      !operators.includes(nextExpData?.value)
    ) {
      return "Please add valid expression, If bracket closed then its next expression should start with operator";
    }
    // 6. if bracket Open then next expression shouldn't be symbol
    if (expValue == "(" && operators.includes(nextExpData?.value)) {
      return "Please add valid expression, If bracket Open then its next expression shouldn't be symbol";
    }
    // 7. if current expression is operator then next expression shouldn't be closed bracket
    if (operators.includes(expValue) && nextExpData?.value == ")") {
      return "Please add valid expression, If current expression is operator then next expression shouldn't be closed bracket";
    }
    // 8. First expression shouldn't be close bracket
    if (index == 0 && expValue == ")") {
      return "Please add valid expression, First expression shouldn't be close bracket";
    }
    // 9. Last expression shouldn't be open bracket
    if (index == expressions.length - 1 && expValue == "(") {
      return "Please add valid expression, Last expression shouldn't be open bracket";
    }
    // 10. If prev expression is bracket open then next expression must be operator
    if (
      prevExpData?.value == "(" &&
      expValue !== "(" &&
      !operators.includes(nextExpData?.value)
    ) {
      return "Please add valid expression, Minimum 2 fields and one operator is required inside brackets";
    }
    // 11. If next expression is bracket close then previous expression must be operator
    if (
      nextExpData?.value == ")" &&
      expValue !== ")" &&
      !operators.includes(prevExpData?.value)
    ) {
      return "Please add valid expression, Minimum 2 fields and one operator is required inside brackets";
    }
    // 12. A Number previous expression must not be field.
    if (!isNaN(parseFloat(expValue)) && index !== 0 && prevExpData?.fieldId) {
      return "Please add valid expression, A Number previous expression must not be field";
    }
    // 13. 2 Operator must not be together.
    if (
      operators.includes(expValue) &&
      operators.includes(prevExpData?.value)
    ) {
      return "Please add valid expression, Two operator must not be placed together";
    }

    // 13. A Number next expression must not be field.    // not required
    // if (
    //   !isNaN(parseFloat(expValue)) &&
    //   index !== expressions.length - 1 &&
    //   nextExpData?.fieldId
    // ) {
    //   return "Please add valid expression, A Number next expression must not be field";
    // }
  }
  if (closingBracketCount > openingBracketCount) {
    validationError = "Please add valid expression, Opening bracket is missing";
  } else if (openingBracketCount > closingBracketCount) {
    validationError = "Please add valid expression, Closing bracket is missing";
  } else if (!fieldExistInFormula) {
    validationError = "Calculative field must contain a field";
  }
  return validationError;
};

export const transformExpressionFromObjectToStringAndEvaluate = (
  expressions: IExpression[],
  fieldsSubmissionMap: IFieldSubmissionMap
): string => {
  let expressionString = "";
  let hasFunctionToEvaluate = false;
  let functionResult = "";
  expressions?.forEach((expression) => {
    const fieldIdValue = expression?.fieldId;
    const fieldId = fieldIdValue?.replace(/{{\s*|\s*}}/g, "");
    const functionType = expression?.functionType;
    let value = expression?.value ?? "";

    if (functionType) {
      hasFunctionToEvaluate = true;
      functionResult = evaluateFunction(
        functionType,
        expression.selectedArgs || "",
        fieldsSubmissionMap
      );
      value = functionResult;
    } else if (fieldId) {
      const fieldData = fieldsSubmissionMap[fieldId];
      value = fieldData?.fieldSubmissionValue?.value || value || "0";
      if (fieldData && fieldData?.fieldType == FormFieldTypes.LINEAR_SCALING) {
        value = fieldData?.fieldSubmissionValue?.selectedOption || "0";
      } else if (fieldData && fieldData?.fieldType == FormFieldTypes.PAYMENT) {
        value = fieldData?.fieldSubmissionValue?.paymentValue?.amount || "0";
      }
      if (typeof value === "string" && /^-?0[0-9]+$/.test(value)) {
        value = String(Number(value));
      }
    }
    expressionString = expressionString + value;
  });
  try {
    console.log("calculationExpression", expressionString);
    let result = eval(expressionString);
    if (result === Infinity || result === -Infinity) {
      return "0";
    }
    return result + "";
  } catch (e) {
    console.log("error",e)
    return "0";
  }
};
const evaluateFunction = (
  functionType: string,
  args: string,
  fieldsSubmissionMap: IFieldSubmissionMap
): string => {
  const argArray = args?.split(",").map((arg) => arg.trim());
  switch (functionType) {
    case "Add": {
      const values = argArray.map((fieldId) => {
        const fieldData = fieldsSubmissionMap[fieldId];
        if (!fieldData) return 0;

        if (fieldData.fieldType === FormFieldTypes.LINEAR_SCALING) {
          return Number(fieldData.fieldSubmissionValue?.selectedOption || 0);
        } else if (fieldData.fieldType === FormFieldTypes.PAYMENT) {
          return Number(
            fieldData.fieldSubmissionValue?.paymentValue?.amount || 0
          );
        } else {
          return Number(fieldData.fieldSubmissionValue?.value || 0);
        }
      });

      const sum = values.reduce((acc, curr) => acc + curr, 0);
      return sum.toString();
    }

    case "DaysBetween": {
      if (argArray?.length < 2) return "0";
      const dates = argArray.map((fieldId) => {
        const fieldData = fieldsSubmissionMap[fieldId];
        if (!fieldData || fieldData.fieldType !== FormFieldTypes.DATE_INPUT)
          return null;
        return new Date(fieldData.fieldSubmissionValue?.value || "");
      });

      if (
        !dates[0] ||
        !dates[1] ||
        isNaN(dates[0].getTime()) ||
        isNaN(dates[1].getTime())
      ) {
        return "0";
      }

      const diffTime = Math.abs(dates[1].getTime() - dates[0].getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return (diffDays + 1).toString();
    }

    default:
      return "0";
  }
};

export const transformExpressionToString = (
  expressions: IExpression[],
  fieldsMap: IFieldsMap
): string => {
  let expressionString = "";
  expressions.forEach((expression) => {
    const fieldId = expression?.fieldId;
    let value = expression?.value + " " || "";
    if (fieldId && fieldsMap) {
      const fieldData = fieldsMap[fieldId];
      value = fieldData?.title + " " || "";
    }
    expressionString = expressionString + value;
  });
  return expressionString;
};

export const transformExpressionFromClientToServer = (
  expressions: IExpression[]
): string => {
  let expressionString = "";
  expressions?.forEach((expression) => {
    const fieldId = expression?.fieldId;
    const fieldIdValue = fieldId?.replace(/{{\s*|\s*}}/g, '');

    let value = expression?.value ?? "";
    const fieldFunction = expression?.functionType;
    if (fieldId) {
      value = "{{" + fieldIdValue + "}}";
    }
    if (fieldFunction) {
      value = getAction(expression?.functionType, expression?.selectedArgs);
    }
    expressionString = expressionString + value;
  });
  return expressionString;
};
const extractFunctionDetails = (expression: string) => {
  const functionRegex = /^(\w+)\(([^)]+)\)$/; 
  const match = expression.match(functionRegex);

  if (!match) return null; 
  const functionName = match[1];
  const selectedFieldValues = match[2];

  return { functionName, selectedFieldValues };
};
export const transformExpressionFromServerToClient = (
  expressionString: string
): IExpression[] => {
  const regex = /([+\-*/()])|(\b\w+\b\([^)]*\))|(\{\{[\w-]+\}\})/g; 
  const convertedValue = expressionString.split(regex).filter(Boolean);
  const convertedExpression: IExpression[] = [];

  convertedValue?.forEach((item) => {
    if (!item) return;
    let expressionType: ExpressionType;
    let expressionValue: string;
    let fieldId: string | undefined;
    let functionName: string;
    let selectedArgs: string;

    if (bracketType.includes(item)) {
      expressionType = ExpressionType.BRACKETS;
      expressionValue = item;
    } else if (operators.includes(item)) {
      expressionType = ExpressionType.OPERATOR;
      expressionValue = item;
    } else if (!isNaN(Number(item))) {
      expressionType = ExpressionType.TEXT;
      expressionValue = item;
    } else if (/^\w+\(.*\)$/.test(item)) {
      const functionData = extractFunctionDetails(item);
      expressionType = ExpressionType.FUNCTION;
      expressionValue = item;
      functionName = functionData?.functionName;
      selectedArgs = functionData?.selectedFieldValues;
    } else {
      expressionType = ExpressionType.FIELD;
      fieldId = item;
    }

    const expression: IExpression = {
      type: expressionType,
      value: expressionValue,
      fieldId: fieldId,
      selectedArgs: selectedArgs,
      functionType: functionName as FunctionEnum,
    };
    
    convertedExpression?.push(expression);
  });
  return convertedExpression;
};
export const functionsData: IFunction[] = [
  {
    id: FunctionEnum.Add,
    label: "add()",
    description: "finds the sum",
    args: [
      { name: "Value 1", type: "number" },
      { name: "Value 2", type: "number" },
    ],
    fieldType: FormFieldTypes.NUMBER_INPUT,
  },
  {
    id: FunctionEnum.DaysBetween,
    label: "daysBetween()",
    description: "Calculate days between dates",
    args: [
      { name: "Start Date", type: "date" },
      { name: "End Date", type: "date" },
    ],
    fieldType: FormFieldTypes.DATE_INPUT,
  },
];
